import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const Panel = ({
  title,
  action,
  children,
  sx = {},
  bodySx = {},
  headerSx = {},
  titleSx = {},
  actionSx = {}
}) => (
  <Paper
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: '14px',
      overflow: 'hidden',
      ...sx
    }}
  >
    {(title || action) && (
      <Box
        sx={{
          minHeight: 58,
          px: 2.25,
          py: 1.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid',
          borderColor: 'divider',
          ...headerSx
        }}
      >
        {title && <Typography sx={{ fontWeight: 700, ...titleSx }}>{title}</Typography>}
        {action && <Box sx={{ display: 'flex', alignItems: 'center', ...actionSx }}>{action}</Box>}
      </Box>
    )}
    <Box sx={{ p: 2.25, ...bodySx }}>{children}</Box>
  </Paper>
);

export default Panel;
